import axios from "axios"
import { useQuery } from "@tanstack/react-query"

function useFetchOptions({ url, queryKey }) {
  const {
    data = [],
    refetch,
    ...restQuery
  } = useQuery({
    queryKey: [queryKey],
    queryFn: async () => {
      return await axios.get(url)
    },
    staleTime: "Infinity",
    gcTime: "Infinity",
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  })

  const fetchOptions = () => {
    refetch()
  }
  return { options: data, fetchOptions, ...restQuery }
}

export default useFetchOptions
